"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _formik = require("formik");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormContainer = _ref => {
  var {
    children,
    initialValues,
    validationSchema,
    handleSubmit,
    handleChange
  } = _ref;
  return (
    /*#__PURE__*/
    //CREO EL COMPONENTE DE FORMIK
    _react.default.createElement(_formik.Formik, {
      validateOnMount: true,
      validationSchema: validationSchema,
      initialValues: initialValues,
      onSubmit: handleSubmit,
      validateOnChange: true
    }, formik => /*#__PURE__*/_react.default.createElement(_formik.Form, null, handleChange(formik), children))
  );
};

var _default = FormContainer;
exports.default = _default;